/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CourierPackageImportPackagesFromCsvRequest
 */
export interface CourierPackageImportPackagesFromCsvRequest {
    /**
     * 
     * @type {string}
     * @memberof CourierPackageImportPackagesFromCsvRequest
     */
    applicationId?: string;
    /**
     * 
     * @type {string}
     * @memberof CourierPackageImportPackagesFromCsvRequest
     */
    fileName?: string;
}

/**
 * Check if a given object implements the CourierPackageImportPackagesFromCsvRequest interface.
 */
export function instanceOfCourierPackageImportPackagesFromCsvRequest(value: object): value is CourierPackageImportPackagesFromCsvRequest {
    return true;
}

export function CourierPackageImportPackagesFromCsvRequestFromJSON(json: any): CourierPackageImportPackagesFromCsvRequest {
    return CourierPackageImportPackagesFromCsvRequestFromJSONTyped(json, false);
}

export function CourierPackageImportPackagesFromCsvRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CourierPackageImportPackagesFromCsvRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'applicationId': json['applicationId'] == null ? undefined : json['applicationId'],
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
    };
}

export function CourierPackageImportPackagesFromCsvRequestToJSON(json: any): CourierPackageImportPackagesFromCsvRequest {
    return CourierPackageImportPackagesFromCsvRequestToJSONTyped(json, false);
}

export function CourierPackageImportPackagesFromCsvRequestToJSONTyped(value?: CourierPackageImportPackagesFromCsvRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'applicationId': value['applicationId'],
        'fileName': value['fileName'],
    };
}

